/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Member_NoInputs */

const vi_grower_member_no = /** @type {(inputs: Grower_Member_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không`)
};

/**

* @param {Grower_Member_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_member_no = /** @type {((inputs?: Grower_Member_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Member_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_member_no(inputs)
});